// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4842) return "static/chunks/4842-2f0a7025fd2bed1a.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"190":"b8f7ff02bf2eb1c2","566":"beae81f03f1f5278","1807":"940d0ebe050419b4","2989":"2ed5bcdc8cc3a5d9","3076":"77198588aa5bc860","3175":"f69c91efbf490bc1","5463":"34b586621bc754a3","6452":"87611b81cf87e731","7049":"07c34b83abcbc23c","7785":"4f9bf87f58c160ec","9395":"149c8350aa0d4132"}[chunkId] + ".js";
};